module.exports = __webpack_public_path__ + "media/images/contest/con-waiting-icon-f4b127a99a113a22db1d60036e97daf9.svg";